<template>
  <Training />
</template>

<script>
import Training from '@/components/content/education/EditViewSingleEducation.vue'

export default {
  name: 'ContentTrainingHistory',
  components: { Training }
}
</script>

<style scoped>

</style>
